import { Popover, Typography } from 'antd';

import { isEmpty } from 'lodash';

import { EmptyGroup } from '../../components';

import { AllergenContent } from '../AllergenElement';

import { checkDiffAllergenOverlay } from './utils';

export const AllergenOverlayValueWrapper = ({
  originalValue,
  valueOverlay,
  children,
  ...rest
}) => {
  const isDiffValue = checkDiffAllergenOverlay({
    allergenOverlay: valueOverlay,
    originalAllergen: originalValue,
  });

  let element = children;

  if (isDiffValue) {
    element = (
      <Popover
        title={<Typography.Text strong>Original Value</Typography.Text>}
        trigger='hover'
        overlayInnerStyle={{ minWidth: 400, paddingBottom: 4 }}
        {...rest}
      >
        <div
          style={{
            background: '#e6f7ff',
            marginBottom: 2,
          }}
        >
          {children}
        </div>
      </Popover>
    );
  }

  return element;
};

export const AllergenContentFieldOverlay = ({
  originalValue,
  valueOverlay,
  children,
}) => {
  const isDiffValue = originalValue !== valueOverlay;
  let element = <>{children}</>;

  if (isDiffValue) {
    element = (
      <div
        style={{
          background: '#e6f7ff',
          marginBottom: 2,
        }}
      >
        {children}
      </div>
    );
  }

  return <>{element}</>;
};

export const AllergenOverlay = ({
  originalAllergen,
  allergenOverlay,
  displayFields = [],
}) => {
  return (
    <AllergenOverlayValueWrapper
      originalValue={originalAllergen}
      valueOverlay={allergenOverlay}
      content={
        <>
          {isEmpty(originalAllergen) ? (
            <EmptyGroup description='No allergen found' />
          ) : (
            <>
              {displayFields.map((field) => {
                return (
                  <AllergenContentFieldOverlay
                    originalValue={originalAllergen[field.fieldName] ?? ''}
                    valueOverlay={allergenOverlay[field.fieldName] ?? ''}
                    content={
                      <AllergenContent
                        key={field.fieldName}
                        label={field.displayName}
                        value={originalAllergen[field.fieldName]}
                        type={field.type}
                      />
                    }
                  >
                    <AllergenContent
                      key={field.fieldName}
                      label={field.displayName}
                      value={originalAllergen[field.fieldName]}
                      type={field.type}
                    />
                  </AllergenContentFieldOverlay>
                );
              })}
            </>
          )}
        </>
      }
    >
      {displayFields.map((field) => {
        return (
          <AllergenContent
            key={field.fieldName}
            label={field.displayName}
            value={allergenOverlay[field.fieldName]}
            type={field.type}
          />
        );
      })}
    </AllergenOverlayValueWrapper>
  );
};
